
import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux';
import { deleteTimeslotByBookingId, editTimeslotByBookingId, loadDatesWithTimeslot, loadPrenotationList } from '../../redux/reducer/prenotationReducer';
import { forceTimeslotListUpdate } from "../../redux/reducer/prenotationViewReducer";
import { HttpService } from '../../services/HttpService';
import AlertMessageModal from '../alertMessageModal';
import AutoComplite from '../common/autoComplite';
import BoxTag from '../common/boxTag';
import ButtonIcon from '../common/buttonIcon';
import ButtonSubmit from '../common/buttonSubmit';
import ButtonWhite from '../common/buttonWhite';
import DatePickerInput from '../common/datePickerInput';
import ErrorMessageBox from '../common/errorMessageBox';
import FormFields from './formFields';

const BoxPrenotationByBooking = (props: any) => {
  let attendances: any[] = props.attendances ?? [];
  let otherInvitations = attendances.filter((attendance: any, index: any) => index !== 0);
  let openBox = props.openBox ?? false;
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(openBox);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageModal, setErrorMessageModal] = useState("");
  const [openEditPrenotation, setOpenEditPrenotation] = useState(false);

  const [day, setDay] = useState("");
  const [paramsDateAvability, setParamsDateAvability] = useState<any[]>([]);

  const [timeslotSelect, setTimeslotSelect] = useState("");
  const [paramsTimeslotAvability, setParamstimeslotAvability] = useState<any[]>([]);
  const { eventId } = useSelector((state: any) => state.login);
  const [loadSpinner, setLoadSpinner] = useState(false);
  const [activeDelete, setActiveDelete] = useState(false);
  let timeslot = attendances[0]?.timeSlot;
  let bookingId = attendances[0]?.bookingId;

  const scrollRef = useRef<null | HTMLDivElement>(null)

  useEffect(() => {
    setOpen(openBox)
  }, [attendances])

  useEffect(() => {
    if (openBox) {
      scrollRef?.current?.scrollIntoView()
    }
  }, [])


  const clickDelete = () => {
    if (open) {
      setOpen(false);
      setTimeout(() => {
        setActiveDelete(true);
      }, 400)
    }
    else {
      setActiveDelete(true);
    }
  }

  /**
   * Show gui to move the booking from timeslot to timeslot.
   */
  const editTimeslot = async () => {
    // load possible destination days
    const result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslotid/${timeslot}/bookingid/${bookingId}/days?category=${attendances[0].timeslotCategoryObject._id}`);
    let days = result.data.result;
    if (days.length) {
      setParamsDateAvability(days.map((day: any) => day._id));
    } else {
      setParamsDateAvability([new Date()]); // TODO why "now" if no dates??
    }

    // reset destination day and time
    setDay("");
    setTimeslotSelect("");

    // show gui
    setOpenEditPrenotation(true);
  }

  /**
   * Update possible destination times in moving booking, based on selected day.
   * @param value selected day
   */
  const ChangeSelectDay = async (value: any) => {
    if (value) {
      const response = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslotid/${timeslot}/bookingid/${bookingId}/day/${value}?category=${attendances[0].timeslotCategoryObject._id}`);
      let timeslots = response.data.result.map((timeslot: any) => {
        return {
          "label": moment(timeslot.startDate).format("HH:mm") + " - " + moment(timeslot.endDate).format("HH:mm"),
          "value": timeslot._id
        }
      });
      setParamstimeslotAvability(timeslots);
    } else {
      setParamstimeslotAvability([]);
    }

    // reset possible previous error message... ??
    setErrorMessage("");
    // update day value to send
    setDay(value);
  }

  const deleteBooking = async () => {
    const result = await dispatch(deleteTimeslotByBookingId(bookingId));
    if (result.status === 200) {
      let invitationNew = Object.assign({}, attendances[0]);
      invitationNew.delete = true;
      props.changeInfoOldAttendances(invitationNew)
      setErrorMessage("");
      setActiveDelete(false)

      onDataUpdate();
    }
    if (result.status > 401) {
      setErrorMessageModal(result?.data.result.message)
      setActiveDelete(false)
    }
  }

  /**
   * Move booking in another timeslot
   */
  const saveChangePrenotation = async () => {
    setErrorMessage("");
    setLoadSpinner(true);

    const result = await dispatch(editTimeslotByBookingId(bookingId, timeslotSelect));
    if (result.status === 200) {
      // organize new timeslot data for the parent
      let invitationNew = Object.assign({}, attendances[0]);
      invitationNew.day = day;
      // HAX translate DD-MM-YYYY into YYYY-MM-DD
      const dateSplit = day.split('-');
      invitationNew.ISODay = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
      invitationNew.startDateNow = paramsTimeslotAvability.find((param: any) => param.value === timeslotSelect)?.label;
      invitationNew.timeSlot = timeslotSelect;
      // give back data to the parent in order to show a success message
      props?.changeInfoOldAttendances(invitationNew);

      onDataUpdate();
    }
    if (result.status > 401) {
      setErrorMessage(result?.data.error);
    }

    setLoadSpinner(false);
  }

  const onTimeslotOptionChange = (option: any) => {
    setTimeslotSelect(option.value);
  }

  // refresh lists on update
  const onDataUpdate = () => {
    props.updateBookings();
    dispatch(loadDatesWithTimeslot());
    dispatch(forceTimeslotListUpdate());
    dispatch(loadPrenotationList());
  }

  return (
    <>
      <div className='BoxPrenotationByBooking'
        ref={openBox ? scrollRef : null}
      >
        <div className={`DeleteBooking ${activeDelete ? "active" : ''}`}>
          <div className='row m-0'>
            <div className='col-10 p-0 '>
              <span className="material-symbols-outlined Icon">
                warning
              </span>
              <h4>VUOI CANCELLARE {attendances[0]?.guestObject.name} {attendances[0]?.guestObject.surname}</h4>
              <h5>Codice prenotazione: #{attendances[0]?.bookingId}</h5>
            </div>
            <div className='col-2 p-0 text-right'>
              <ButtonIcon icon="done" handleClick={() => (deleteBooking())} />
              <ButtonIcon handleClick={() => (setActiveDelete(false))} icon="close" />
            </div>
          </div>
        </div>
        <div className='row m-0'>
          <div className='col-lg-8 pl-0'>
            <ButtonIcon icon={((open) ? "arrow_drop_up" : "arrow_drop_down")} handleClick={() => (((open) ? setOpen(false) : setOpen(true)))} />
            <h6><b>{attendances[0]?.guestObject.name} {attendances[0]?.guestObject.surname}</b> Codice prenotazione: <b>#{attendances[0]?.bookingId}</b></h6>
          </div>
          <div className='col-lg-2 text-center'>
            {((attendances[0]?.createdById) ?
              <BoxTag label="Farmacista" color="#9ea2a4" />
              :
              <BoxTag label="Cittadino" color="#5FB5EB" />
            )}
          </div>
          <div className='col-lg-2 text-right'>
            <ButtonIcon handleClick={() => { props.openPopUpNote(attendances[0]?.bookingId, `${attendances[0]?.guestObject.name} ${attendances[0]?.guestObject.surname}`) }} icon="sticky_note_2" />
            <ButtonIcon handleClick={clickDelete} icon="delete" />
          </div>
        </div>
        <Collapse in={open}>
          <div className='Content'>
            {((attendances[0]?.timeslotCategoryObject.name) ?
              <p>Servizio:
                <span style={{ background: attendances[0].timeslotCategoryObject.color }} className="Tag mr-2">{attendances[0].timeslotCategoryObject.name}</span>
              </p>
              :
              <></>)}
            {((open) ?
              <FormFields id={attendances[0]?._id} />
              :
              <></>
            )}

            {((otherInvitations.length && open) ?
              <>
                <p className='mt-4'><b>Ospiti aggiuntivi</b></p>
                {(otherInvitations.map((otherInvitation: any, index: any) => (
                  <div key={index}>
                    <p >Ospite {index + 1}</p>
                    <FormFields id={otherInvitation?._id} />
                  </div>
                )))}
              </>
              :
              <></>)}
            <div className='Footer pl-0'>
              {((!openEditPrenotation) ?
                <div className='col-lg-12  text-right'>
                  <ButtonSubmit handleChange={() => (editTimeslot())} textButton={t('edit-prenotation')} />
                </div>
                :
                <div className='col-lg-12 pl-0'>
                  <div className='row m-0'>
                    <div className='col-lg-6 pl-0'>
                      <DatePickerInput handleChange={ChangeSelectDay} dateSelected={((day) ? new Date(moment(day, "DD-MM-YYYY").format("YYYY-MM-DD")) : null)} showDates={paramsDateAvability} firstSelect='Seleziona' />
                      {((paramsTimeslotAvability.length) ?
                        <AutoComplite
                          height="37"
                          handleChange={onTimeslotOptionChange}
                          params={paramsTimeslotAvability}
                          value={timeslotSelect}
                          firstSelect='Seleziona'
                        />
                        :
                        <></>
                      )}
                    </div>
                    <div className='col-lg-6 text-right'>
                      <ButtonWhite textButton={t('cancel')} handleChange={() => (setOpenEditPrenotation(false))} />
                      <ButtonSubmit spinner={loadSpinner} disabled={(day === "" || timeslotSelect === "")} handleChange={() => (saveChangePrenotation())} textButton={t('save')} />
                    </div>
                    <ErrorMessageBox errorMessage={errorMessage} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Collapse>
      </div>
      <AlertMessageModal
        show={(errorMessageModal !== "")}
        title={t('attention')}
        closeModal={() => (setErrorMessageModal(""))}
        description={errorMessageModal}
      />
    </>
  )
}

export default BoxPrenotationByBooking